import React, { useEffect, useMemo, useState } from 'react'
import styles from 'components/Nav/nav.module.scss'
import clsx from 'clsx'
import { Container, Icon, Typography } from 'gu-ui-kit'
import config from 'components/Nav/config'
import { NavLink } from 'react-router-dom'
import Nav from 'components/Nav'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import findMatchedRoutes from 'utils/findMatchedRoutes'
import { useLocation } from 'react-router'

const SubLevel = ({ label_key, exact, path, icon, routes = [], level, routeKey = '' }) => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  const matchedRoutes = findMatchedRoutes(routes)
  const to = Array.isArray(path) ? path[0] : path
  const [open, setOpen] = useState(routes.length > 0 && matchedRoutes.length > 0)
  const location = useLocation()

  const LinkComponent = useMemo(() => {
    if (config?.[routeKey]) {
      return config?.[routeKey]
    }

    if (routes?.length > 0) {
      return 'div'
    }

    return NavLink
  }, [routes, routeKey])

  useEffect(() => {
    if (routes.length > 0) {
      setOpen(matchedRoutes.length > 0)
    }
  }, [location])

  return (
    <div key={routeKey} className={styles['nav__item']}>
      <LinkComponent
        title={t(label_key)}
        className={clsx(styles['nav__link'], {
          //eslint-disable-next-line
          [styles['nav__link_opener']]: routes?.length > 0,
          ['opened']: open,
          ['nav__link_opener']: routes?.length > 0,
          [styles['nav__link_active']]: routes?.length > 0 && !open && matchedRoutes.length > 0,
        })}
        onClick={() => {
          //eslint-disable-next-line
          if (routes?.length > 0) {
            setOpen((open) => !open)
            return false
          }

          return true
        }}
        activeClassName={styles['nav__link_active']}
        exact={exact}
        to={pathGen(to)}
      >
        {open}
        <span className={styles['nav__icon']}>{React.cloneElement(icon, { width: 20 })}</span>
        <Typography variant={'Body-15'} className={styles['nav__text']} noMargin>
          {t(label_key)}
        </Typography>

        {
          //eslint-disable-next-line
          routes?.length > 0 && (
            <span className={styles['nav__link_opener']}>
              <Icon
                className={styles['nav__link_opener-icon']}
                width={20}
                name={open ? 'arrow-up' : 'arrow1-down'}
                size={'m'}
              />
            </span>
          )
        }
      </LinkComponent>
      {
        //eslint-disable-next-line
        routes?.length > 0 && (
          <Container
            display={'flex'}
            className={clsx(styles['collapse-wrapper'], {
              ['opened']: open,
            })}
          >
            <Nav items={routes} level={level + 1} />
          </Container>
        )
      }
    </div>
  )
}

export default SubLevel

SubLevel.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  exact: PropTypes.bool,
  routeKey: PropTypes.string,
  label_key: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object),
  level: PropTypes.number.isRequired,
  openedGroup: PropTypes.string,
  setOpenedGroup: PropTypes.func,
}
